import * as analytics from '@benniehealth/core-js/analytics';

import { USER_ROLES } from '@app/constants/user';

let mp = null;
const pendingCalls = [];

function enqueue(method, args) {
  if (mp) {
    const fn =
      method === 'people.set'
        ? mp.people.set.bind(mp.people)
        : mp[method]?.bind(mp);
    fn?.(...args);
  } else {
    pendingCalls.push({ method, args });
  }
}

function flush() {
  while (pendingCalls.length > 0) {
    const { method, args } = pendingCalls.shift();
    const fn =
      method === 'people.set'
        ? mp.people.set.bind(mp.people)
        : mp[method]?.bind(mp);
    fn?.(...args);
  }
}

export const init = (...args) =>
  import('mixpanel-browser').then(mod => {
    mp = mod.default || mod;
    mp.init(...args);
    flush();
  });

export const disable = () => enqueue('disable', []);

export const setProfile = (...args) => enqueue('people.set', args);

export const reset = () => enqueue('reset', []);

export const identify = (...args) => enqueue('identify', args);

export const setGroup = (groupKey, groupId) =>
  enqueue('set_group', [groupKey, groupId]);

export const track = (...args) => enqueue('track', args);

export const getAccessType = access => {
  let accessTypeAnalytics;

  if (access === USER_ROLES.HR_ADMIN) {
    accessTypeAnalytics = analytics.admin.SET_ACCESS_HR_ADMIN;
  }

  if (access === USER_ROLES.EMPLOYEE) {
    accessTypeAnalytics = analytics.admin.SET_ACCESS_EMPLOYEE;
  }

  if (access === USER_ROLES.SYSTEM_ADMIN) {
    accessTypeAnalytics = analytics.admin.SET_ACCESS_SYSTEM_ADMIN;
  }

  return accessTypeAnalytics;
};

export const registerOnce = (...args) => enqueue('register_once', args);

export const register = (...args) => enqueue('register', args);
